import { createGlobalStyle } from 'styled-components';

export const RtlStyles = createGlobalStyle`
  body.rtl {
    /* RTL-specific styles */
    text-align: right;
    
    /* Flip icons */
    .icon:not(.no-flip) {
      transform: scaleX(-1);
    }
    
    /* Adjust form elements */
    input, select, textarea {
      text-align: right;
    }
    
    /* Adjust flexbox directions */
    .flex-row {
      flex-direction: row-reverse;
    }
    
    /* Adjust margins and paddings */
    .ml-auto {
      margin-left: 0;
      margin-right: auto;
    }
    
    .mr-auto {
      margin-right: 0;
      margin-left: auto;
    }
    
    /* Navbar specific adjustments */
    nav .nav-links {
      flex-direction: row-reverse;
    }
    
    /* Form specific adjustments */
    form label {
      text-align: right;
    }
    
    /* Button icon adjustments */
    button svg {
      margin-left: 0;
      margin-right: 8px;
    }
  }
`; 